
export function msToTime(ms) {
    const pad = (numero, tamanho = 2) => ('00' + numero).slice(-tamanho);
    return pad(ms/3.6e6|0) + ':' + pad((ms%3.6e6)/6e4 | 0) + ':' + pad((ms%6e4)/1000|0);
}